
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Operation } from './operation';
import { OperationService, OperationFilter } from './operation.service';
import { OperationFilterDialogComponent } from './operation-filter-dialog.component';
import { NotifierService, DialogService } from '../ui';

const FILTER_KEY = 'operations.filter';

@Component({
  templateUrl: './operation-list.component.html',
})
export class OperationListComponent implements OnInit {

  filter: OperationFilter;

  perPage = 10
  operationsCount: number = 0
  operations: Operation[]

  constructor(
    private operationService: OperationService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new OperationFilter();

    // Set default ordering to NAME/ASC
    this.filter.order_by = 'NAME';
    this.filter.order_direction = 'ASC';

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.operations.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.operationService
      .operations(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.operations = result.operations;
        }
        // Append
        else {
          this.operations = [...this.operations || [], ...result.operations];
        }

        this.operationsCount = result.operationsCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showRevisions(operation: Operation, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['operations', operation.id]);
    }
  }

  delete(operation: Operation) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cette opération?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.operationService
          .delete(operation.id)
          .subscribe((id) => {
            this.notifier.success('Opération supprimée avec succès');

            this.fetch(0, this.operations.length, true);

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }

  applyFilter() {
    this.dialogService.show({
      component: OperationFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: OperationFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  clearCategory() {
    this.filter.category = null;

    this.fetch(0, this.perPage, true);
  }
}
